var render = function render(_c,_vm){return _c('div',{class:['list-item-apps', { connected: _vm.props.isAppShared, disabled: _vm.props.isHoverDisabled }],on:{"click":_vm.listeners.click}},[_c('img',{staticClass:"list-item-apps__icon",attrs:{"src":_vm.props.iconPath,"alt":"app-icon"}}),_c('div',{staticClass:"list-item-apps__text caption2"},[_vm._v(" "+_vm._s(_vm.props.itemName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }